<template>
		<div class='result-table-1'>
		<table class='table-common'>
			<thead>
				<tr>
					<th>Год проведения лесоустройства</th>
					<th>Номер квартала</th>
					<th>Номер выдела</th>
					<th>Площадь выдела, га</th>
					<th>Целевое назначение лесов</th>
					<th>Категория защитных лесов</th>
					<th>ОЗУ</th>
					<th>Источник данных</th>
					<th>Номер лп выдела</th>
					<th>Площадь лп выдела, га</th>
				</tr>
			</thead>
			<tbody>

				<template v-if='dataIsLoading'>
					<div class='table-common__loading-container'>
						<div>
							<p-spinner class='table-common__loading-spinner'/>
						</div>
						<div class='table-common__loading-text'>Загрузка данных...</div>
					</div>
				</template>

				<template v-if='dataIsLoading && !tableData.length'>
					<tr>
						<td colspan='20' class='table-common__loading-empty-row'></td>
					</tr>
				</template>

				<template v-else>
					<tr v-for='(row, row_i) in tableData.slice(0,-1)'>
						<td v-if='row_i === 0' :rowspan='tableData.length'>{{ row.forest_inventory_year }}</td>
						<td v-if='row_i === 0' :rowspan='tableData.length'>{{ row.area }}</td>
						<td v-if='row_i === 0' :rowspan='tableData.length'>{{ row.section }}</td>
						<td v-if='row_i === 0' :rowspan='tableData.length'>{{ row.s }}</td>
						<td v-if='row_i === 0' :rowspan='tableData.length'>{{ row.forest_purpose }}</td>
						<td v-if='row_i === 0' :rowspan='tableData.length'>{{ row.protection_category }}</td>
						<td v-if='row_i === 0' :rowspan='tableData.length'>{{ row.ozu }}</td>
						<td v-if='isStartSource(row)' :rowspan='getSourceCount(row)'>{{ row.data_source }}</td>
						<td v-if='isStartSource(row)' :rowspan='getSourceCount(row)'>{{ row.section_lp }}</td>
						<td v-if='isStartSource(row)' :rowspan='getSourceCount(row)'>{{ row.s_lp }}</td>
					</tr>
				</template>
				
			</tbody>
		</table>
	</div>


</template>

<script>
	const GET_TABLE_DATA = process.env.VUE_APP_ROOT_API + 'get_site_data/result_tables/table1.php';

	export default {
		name: 'ResultTable1',
		data: () => ({
			tableData: [],
			dataIsLoading: false,
		}),
		computed: {
			startSourceList() {
				const result = [];
				for (let item of this.tableData) {
					if (!result.find(row => row.data_source === item.data_source)) {
						result.push(item);
					}
				}
				return result;
			},

			lpo() {
				return this.$store.state.selectedLpo.lpo;
			},
		},

		methods: {
			isStartSource(item) {
				return this.startSourceList.includes(item);
			},

			getSourceCount(item) {
				return this.tableData.filter(row => row.data_source === item.data_source).length;
			},

			getTableData() {
				this.dataIsLoading = true;

				const form = new FormData();
				form.append('lpo_id', this.lpo.lpo_id);

				fetch(GET_TABLE_DATA, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then(res => res.json())
				.then(res => {
					this.tableData = res;
				})
				.catch(err => { throw err; })
				.finally(() => { this.dataIsLoading = false; });
			}
		},
		created() {
			this.getTableData();
		}
	};
</script>

<style lang='scss' scoped src='@/style/tables.scss'></style>